import { render, staticRenderFns } from "./DetailTicket.vue?vue&type=template&id=1ed2aad8"
import script from "./DetailTicket.js?vue&type=script&lang=js&external"
export * from "./DetailTicket.js?vue&type=script&lang=js&external"
import style0 from "./DetailTicket.vue?vue&type=style&index=0&id=1ed2aad8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports